import { unlockScroll } from '@theme/utilities';

/**
 * Horizon overrides for Shopify.actions and Mountain Line mobile stability.
 */
function releaseStaleScrollLocks() {
  const hasOpenLockingUi = Boolean(document.querySelector('dialog[open], details[scroll-lock][open]'));
  const mountainOverlay = document.querySelector('.mlx-easter');
  const openMountainOverlay = mountainOverlay && !mountainOverlay.hasAttribute('hidden');
  if (hasOpenLockingUi || openMountainOverlay) return;

  document.querySelectorAll('dialog, details[scroll-lock]').forEach((owner) => unlockScroll(owner));
  document.documentElement.removeAttribute('scroll-lock');
  if (mountainOverlay?.hasAttribute('hidden') && document.body?.style.overflow === 'hidden') {
    document.body.style.overflow = '';
  }
}

function forceReleaseTransientLocks() {
  document.querySelectorAll('dialog').forEach((dialog) => {
    unlockScroll(dialog);
    if (dialog.open) dialog.close();
  });
  document.querySelectorAll('details[scroll-lock]').forEach((details) => {
    unlockScroll(details);
    details.open = false;
  });
  document.documentElement.removeAttribute('scroll-lock');
  if (document.body?.style.overflow === 'hidden') document.body.style.overflow = '';

  const mountainOverlay = document.querySelector('.mlx-easter');
  if (mountainOverlay && !mountainOverlay.hasAttribute('hidden')) {
    mountainOverlay.setAttribute('hidden', '');
    mountainOverlay.setAttribute('aria-hidden', 'true');
  }
}

function scheduleScrollLockReconcile() {
  requestAnimationFrame(() => requestAnimationFrame(releaseStaleScrollLocks));
}

function initMobileStability() {
  window.addEventListener('pageshow', (event) => {
    // Safari may restore a page from bfcache with a dialog/drawer and its scroll
    // owner still present. Treat transient UI as closed after a history restore.
    if (event.persisted) forceReleaseTransientLocks();
    scheduleScrollLockReconcile();
  });
  window.addEventListener('pagehide', () => {
    // Do not save a locked viewport into Safari's back/forward cache.
    forceReleaseTransientLocks();
  });
  window.addEventListener('focus', scheduleScrollLockReconcile);
  window.addEventListener('orientationchange', scheduleScrollLockReconcile);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleScrollLockReconcile();
  });
  document.addEventListener('theme-drawer:close', scheduleScrollLockReconcile);
  document.addEventListener('dialog:close', scheduleScrollLockReconcile);
  document.addEventListener('toggle', (event) => {
    if (event.target instanceof HTMLDetailsElement && event.target.hasAttribute('scroll-lock') && !event.target.open) {
      scheduleScrollLockReconcile();
    }
  }, { capture: true });
  scheduleScrollLockReconcile();
}

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;
  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });
  actions.openCart.configure({
    async handler() {
      const drawer = /** @type {HTMLElement & {open?: () => void} | null} */ (document.querySelector('theme-drawer#cart-drawer'));
      if (drawer?.open) drawer.open();
      else window.location.href = Theme.routes.cart_url || '/cart';
    },
  });
}

initMobileStability();
if (window.Shopify?.actions) init();
else document.addEventListener('DOMContentLoaded', init, { once: true });
